import { Badge, Box, Code, HStack, Text, VStack } from '@chakra-ui/react'
import type { LifecycleBatchItemResult } from '@/services/admin/contractService'

const statusColorSchemes: Record<LifecycleBatchItemResult['status'], string> = {
  queued: 'green',
  already_queued: 'blue',
  skipped: 'yellow',
  failed: 'red',
}

export function LifecycleBatchItemResults({
  items,
}: {
  items?: LifecycleBatchItemResult[]
}) {
  if (!items?.length) {
    return null
  }

  return (
    <Box borderTopWidth={1} pt={4}>
      <Text fontWeight="medium" mb={2}>Item results</Text>
      <VStack align="stretch" spacing={2} maxH="20rem" overflowY="auto">
        {items.map((item, index) => (
          <Box
            key={`${item.inputId}-${item.resourceId ?? ''}-${index}`}
            borderWidth={1}
            borderRadius="md"
            p={3}
          >
            <HStack justify="space-between" align="start" spacing={3}>
              <VStack align="start" spacing={1} minW={0}>
                <Code fontSize="xs" wordBreak="break-all">{item.inputId}</Code>
                {item.resourceId && (
                  <Text fontSize="xs" color="gray.500">
                    Resource: <Code fontSize="xs">{item.resourceId}</Code>
                  </Text>
                )}
                {item.reason && (
                  <Text fontSize="sm">
                    Reason: <Code fontSize="xs">{item.reason}</Code>
                  </Text>
                )}
                {item.message && (
                  <Text fontSize="sm" color="gray.600">{item.message}</Text>
                )}
              </VStack>
              <Badge colorScheme={statusColorSchemes[item.status]}>
                {item.status}
              </Badge>
            </HStack>
          </Box>
        ))}
      </VStack>
    </Box>
  )
}
